var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "../api";
var ReservationService = /** @class */ (function () {
    function ReservationService() {
    }
    ReservationService.getAllReservations = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/list"), request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    /**
     * Dedicated calendar search by guest profile (name / email / phone / room).
     * Returns up to 50 full reservations (no Page wrapper, no count) — backed by the
     * token-parsed Atlas Search + bounded reservations lookup on the API side.
     */
    ReservationService.searchReservationsByProfile = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/search-by-profile"), request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ReservationService.getAllWithGroupReservations = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/list-with-res-groups"), request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ReservationService.getReservationById = function (id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/list"), {
                            id: [id],
                            limit: {
                                offset: 0,
                                limit: 1
                            }
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, (_a = response.data.content) === null || _a === void 0 ? void 0 : _a[0]];
                }
            });
        });
    };
    ReservationService.createReservation = function (reservation, allowNotify) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = [];
                        if (allowNotify !== undefined) {
                            queryParams.push("allowNotify=".concat(allowNotify));
                        }
                        return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/add?").concat(queryParams.join('&')), reservation)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ReservationService.updateReservation = function (reservation, allowNotify) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = [];
                        if (allowNotify !== undefined) {
                            queryParams.push("allowNotify=".concat(allowNotify));
                        }
                        return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/update?").concat(queryParams.join('&')), reservation)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ReservationService.updateMulti = function (reservations) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/updateMulti"), reservations)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ReservationService.deleteReservation = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/delete"), request)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationService.resendNotification = function (id, trigger) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/resendNotification"), {
                            reservationId: id,
                            trigger: trigger
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ReservationService.getFilterOptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/filterOptions"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    ReservationService.export = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response, url, link;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(ReservationService.URI, "/export"), request, {
                            responseType: 'blob',
                            // allow for up to 5 minutes to wait
                            timeout: 300000
                        })];
                    case 1:
                        response = _a.sent();
                        url = window.URL.createObjectURL(new Blob([response.data]));
                        link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'data.csv');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservationService.URI = "/v3/reservation/reservation";
    return ReservationService;
}());
export { ReservationService };
